export const BuildInfo = {timestamp:1773270962000}
